/* src/app/private/components/active-directory-config/delete-active-directory-config/delete-active-directory-config.component.scss */
/*# sourceMappingURL=delete-active-directory-config.component.css.map */
